module.exports = "/images/vendor/vue-hotel-datepicker/dist/calendar_icon.regular.98f9a773.svg?c38f4cafa91a97bd452f99c7a8d199e7";